import { hostIsCapreit, hostIsCapreitIRES, hostIsCapreitERES } from 'helpers/CurrentWindowLocation';

export const getSuiteRooms = (isInSuite, propertyType = 'apartment') => {
  // TODO: Put into a model in the backend.
  if (hostIsCapreitIRES() && isInSuite) {
    return capreitIresSuiteLocations.sort(compare);
  } else if (hostIsCapreitIRES()) {
    return capreitIresCommonAreaLocations.sort(compare);
  } else if (hostIsCapreitERES() && isInSuite) {
    return capreitEresSuiteLocations.sort(compare);
  } else if (hostIsCapreitERES()) {
    return capreitEresCommonAreaLocations.sort(compare);
  } else if (
    hostIsCapreit() &&
    isInSuite &&
    propertyType &&
    propertyType.toLowerCase() === 'mobile_home'
  ) {
    return capreitMobileHomeSuiteLocations.sort(compare);
  } else if (hostIsCapreit() && isInSuite) {
    return capreitSuiteLocations.sort(compare);
  } else if (hostIsCapreit() && propertyType && propertyType.toLowerCase() === 'mobile_home') {
    return capreitMobileHomeCommonAreaLocations.sort(compare);
  } else if (hostIsCapreit()) {
    return capreitCommonAreaLocations.sort(compare);
  } else {
    return suiteRooms.sort(compare);
  }
};

export const getMaintenanceCategories = (isInSuite, isTenant, propertyType = 'apartment') => {
  if (
    hostIsCapreit() &&
    isInSuite &&
    isTenant &&
    propertyType &&
    propertyType.toLowerCase() === 'mobile_home'
  ) {
    return capreitMobileHomeTenantCategories.sort(compare);
  } else if (hostIsCapreit() && isInSuite && isTenant) {
    return capreitTenantCategories.sort(compare);
  } else if (
    hostIsCapreit() &&
    isInSuite &&
    propertyType &&
    propertyType.toLowerCase() === 'mobile_home'
  ) {
    return capreitMobileHomeSuiteCategories.sort(compare);
  } else if (hostIsCapreit() && isInSuite) {
    return capreitSuiteCategories.sort(compare);
  } else if (hostIsCapreit() && propertyType && propertyType.toLowerCase() === 'mobile_home') {
    return capreitMobileHomeCommonAreaCategories.sort(compare);
  } else if (hostIsCapreit()) {
    return capreitCommonAreaCategories.sort(compare);
  } else {
    return []; // TODO CAPREIT-MERGE
    // return maintenanceCategory.sort(compare);
  }
};

export const getTenantPortalRequestType = () => {
  if (hostIsCapreit()) {
    return [{ label: 'selectOptions.isMaintenance', value: 'Portal Request - Maintenance' }];
  }

  return tenantPortalMaintenanceRequestType;
};

export const suiteRooms = [
  { label: 'selectOptions.bathroom', value: 'Bathroom' },
  { label: 'selectOptions.bedroom', value: 'Bedroom' },
  { label: 'selectOptions.corridor', value: 'Corridor' },
  { label: 'selectOptions.entrance', value: 'Entrance' },
  { label: 'selectOptions.exterior', value: 'Exterior' },
  { label: 'selectOptions.kitchen', value: 'Kitchen' },
  { label: 'selectOptions.laundry', value: 'Laundry' },
  { label: 'selectOptions.livingRoom', value: 'Living Room' },
  { label: 'selectOptions.locker', value: 'Locker' },
  { label: 'selectOptions.mechanical', value: 'Mechanical' },
  { label: 'selectOptions.pantry', value: 'Pantry' },
  { label: 'selectOptions.parking', value: 'Parking' },
  { label: 'selectOptions.stairs', value: 'Stairs' },
  { label: 'selectOptions.walkInCloset', value: 'Walk-in Closet' },
  { label: 'selectOptions.other', value: 'Other' },
];

export const capreitSuiteLocations = [
  { label: 'selectOptions.balcony', value: 'Balcony' },
  { label: 'selectOptions.basement', value: 'Basement' },
  { label: 'selectOptions.bathroom', value: 'Bathroom' },
  { label: 'selectOptions.bedroom', value: 'Bedroom' },
  { label: 'selectOptions.diningRoom', value: 'Dining Room' },
  { label: 'selectOptions.kitchen', value: 'Kitchen' },
  { label: 'selectOptions.livingRoom', value: 'Living Room' },
  { label: 'selectOptions.privateOutdoorSpace', value: 'Private Outdoor Space' },
  { label: 'selectOptions.other', value: 'Other' },
];

export const capreitCommonAreaLocations = [
  { label: 'selectOptions.boilerMechRoom', value: 'Boiler/Mech.room' },
  { label: 'selectOptions.commercial', value: 'Commercial' },
  { label: 'selectOptions.compactorRoom', value: 'Compactor Room' },
  { label: 'selectOptions.elevatorRoom', value: 'Elevator Room' },
  { label: 'selectOptions.garbageCompound', value: 'Garbage Compound' },
  { label: 'selectOptions.garbageRoom', value: 'Garbage Room' },
  { label: 'selectOptions.generatorRoom', value: 'Generator Room' },
  { label: 'selectOptions.grounds', value: 'Grounds' },
  { label: 'selectOptions.hallwaysAndStairways', value: 'Hallways and Stairways' },
  { label: 'selectOptions.laundryRoom', value: 'Laundry Room' },
  { label: 'selectOptions.lobby', value: 'Lobby' },
  { label: 'selectOptions.office', value: 'Office' },
  { label: 'selectOptions.parkingLots', value: 'Parking Lots' },
  { label: 'selectOptions.poolChangeRooms', value: 'Pool and Change Rooms' },
  { label: 'selectOptions.pumpRoom', value: 'Pump Room' },
  { label: 'selectOptions.playgrounds', value: 'Playgrounds' },
  { label: 'selectOptions.reacreationRooms', value: 'Recreation Rooms' },
  { label: 'selectOptions.roofWalkways', value: 'Roof and Walkways' },
  { label: 'selectOptions.sprinklerRoom', value: 'Sprinkler Room' },
  { label: 'selectOptions.storageLockers', value: 'Storage/Lockers' },
  {
    label: 'selectOptions.undergroundGarageRampsStairs',
    value: 'Underground Garage, Ramps and Stairwells',
  },
  {
    label: 'selectOptions.utilityRooms',
    value: 'Utility Rooms',
  },
];

export const capreitIresSuiteLocations = [
  { label: 'selectOptions.balcony', value: 'Balcony' },
  { label: 'selectOptions.bathroom', value: 'Bathroom' },
  { label: 'selectOptions.bedroom', value: 'Bedroom' },
  { label: 'selectOptions.diningRoom', value: 'Dining Room' },
  { label: 'selectOptions.kitchen', value: 'Kitchen' },
  { label: 'selectOptions.livingRoom', value: 'Living Room' },
  { label: 'selectOptions.privateOutdoorSpace', value: 'Private Outdoor Space' },
  { label: 'selectOptions.utilityRoom', value: 'Utility Room' },
  { label: 'selectOptions.entranceHall', value: 'Entrance Hall' },
  { label: 'selectOptions.storeRoom', value: 'Store Room' },
  { label: 'selectOptions.other', value: 'Other' },
];

export const capreitIresCommonAreaLocations = [
  { label: 'selectOptions.binRoom', value: 'Bin Room' },
  { label: 'selectOptions.boilerMechRoom', value: 'Boiler/Mech.room' },
  { label: 'selectOptions.carPark', value: 'Car Park' },
  { label: 'selectOptions.commercial', value: 'Commercial' },
  { label: 'selectOptions.compactorRoom', value: 'Compactor Room' },
  { label: 'selectOptions.elevatorRoom', value: 'Elevator Room' },
  { label: 'selectOptions.garden', value: 'Garden' },
  { label: 'selectOptions.generatorRoom', value: 'Generator Room' },
  { label: 'selectOptions.grounds', value: 'Grounds' },
  { label: 'selectOptions.hallwaysAndStairways', value: 'Hallways and Stairways' },
  { label: 'selectOptions.liftElevator', value: 'Lift/Elevator' },
  { label: 'selectOptions.lobby', value: 'Lobby' },
  { label: 'selectOptions.office', value: 'Office' },
  { label: 'selectOptions.pumpRoom', value: 'Pump Room' },
  { label: 'selectOptions.playgrounds', value: 'Playgrounds' },
  { label: 'selectOptions.roofWalkways', value: 'Roof and Walkways' },
  { label: 'selectOptions.sprinklerRoom', value: 'Sprinkler Room' },
  { label: 'selectOptions.storageLockers', value: 'Storage/Lockers' },
  {
    label: 'selectOptions.undergroundGarageRampsStairs',
    value: 'Underground Garage, Ramps and Stairwells',
  },
];

export const capreitEresSuiteLocations = [
  { label: 'selectOptions.attic', value: 'Attic' },
  { label: 'selectOptions.balcony', value: 'Balcony' },
  { label: 'selectOptions.basement', value: 'Basement' },
  { label: 'selectOptions.bathroom', value: 'Bathroom' },
  { label: 'selectOptions.bedroom(s)', value: 'Bedroom(s)' },
  { label: 'selectOptions.entireUnit', value: 'Entire Unit' },
  { label: 'selectOptions.entrance', value: 'Entrance' },
  { label: 'selectOptions.exterior', value: 'Exterior' },
  { label: 'selectOptions.facadeOutsiteWall', value: 'Facade (outsite wall)' },
  { label: 'selectOptions.fuseBoxMeterCupboard', value: 'Fuse Box (meter cupboard)' },
  { label: 'selectOptions.garage', value: 'Garage' },
  { label: 'selectOptions.hallway', value: 'Hallway' },
  { label: 'selectOptions.kitchen', value: 'Kitchen' },
  { label: 'selectOptions.livingRoom', value: 'Living Room' },
  { label: 'selectOptions.parkingLots', value: 'Parking Lots' },
  { label: 'selectOptions.roof', value: 'Roof' },
  { label: 'selectOptions.staircase', value: 'Staircase' },
  { label: 'selectOptions.storageRoom', value: 'Storage Room' },
  { label: 'selectOptions.storeRoom', value: 'Store Room' },
  { label: 'selectOptions.toiletGroundFloor', value: 'Toilet ground floor' },
  { label: 'selectOptions.toiletUpperFloor', value: 'Toilet upper floor' },
  { label: 'selectOptions.other', value: 'Other' },
];

export const capreitEresCommonAreaLocations = [
  { label: 'selectOptions.boilerHeating', value: 'Boiler Heating' },
  { label: 'selectOptions.bicycleStorage', value: 'Bicycle storage' },
  { label: 'selectOptions.callPanelMainEntrance', value: 'Call panel main entrance' },
  { label: 'selectOptions.cleaningStorageRoom', value: 'Cleaning Storage Room' },
  { label: 'selectOptions.commercial', value: 'Commercial' },
  { label: 'selectOptions.commercialMessageboard', value: 'Commercial Message board' },
  { label: 'selectOptions.elevator', value: 'Elevator' },
  { label: 'selectOptions.elevatorRoom', value: 'Elevator Room' },
  { label: 'selectOptions.fence', value: 'Fence' },
  { label: 'selectOptions.garageNotUnderground', value: 'Garage not Underground' },
  {
    label: 'selectOptions.garageUndergroundRampsStairwells',
    value: 'Garage Underground Ramps & Stairwells',
  },
  { label: 'selectOptions.garbageRoom', value: 'Garbage Room' },
  { label: 'selectOptions.garden', value: 'Garden' },
  { label: 'selectOptions.gardenInsite', value: 'Garden Insite' },
  { label: 'selectOptions.generatorRoom', value: 'Generator Room' },
  { label: 'selectOptions.grounds', value: 'Grounds' },
  { label: 'selectOptions.hallwaysAndStairways', value: 'Hallways And Stairways' },
  { label: 'selectOptions.mainEntrance', value: 'Main entrance' },
  { label: 'selectOptions.sideEntrance', value: 'Side entrance' },
  { label: 'selectOptions.mailboxes', value: 'Mailboxes' },
  { label: 'selectOptions.mechanicalVentilation', value: 'Mechanical Ventilation' },
  { label: 'selectOptions.office', value: 'Office' },
  { label: 'selectOptions.pumpHydrophoreRoom', value: 'Pump Hydrophore Room' },
  { label: 'selectOptions.roof', value: 'Roof' },
  { label: 'selectOptions.sprinklerRoom', value: 'Sprinkler Room' },
  { label: 'selectOptions.stairwells', value: 'Stairwells' },
  { label: 'selectOptions.storageLockers', value: 'Storage/Lockers' },
  { label: 'selectOptions.other', value: 'Other' },
];

export const capreitMobileHomeSuiteLocations = [
  { label: 'selectOptions.mobileHome.frontYard', value: 'Front Yard' },
  { label: 'selectOptions.mobileHome.backYard', value: 'Back Yard' },
  { label: 'selectOptions.mobileHome.neighboringLot', value: 'Neighboring Lot' },
  { label: 'selectOptions.mobileHome.clubhouse', value: 'Clubhouse' },
  { label: 'selectOptions.mobileHome.commonArea', value: 'Common Area' },
  { label: 'selectOptions.mobileHome.road', value: 'Road' },
  { label: 'selectOptions.mobileHome.onUnderHome', value: 'On/Under Home' },
  { label: 'selectOptions.mobileHome.bathroom', value: 'Bathroom' },
  { label: 'selectOptions.mobileHome.bedroom', value: 'Bedroom' },
  { label: 'selectOptions.mobileHome.kitchen', value: 'Kitchen' },
  { label: 'selectOptions.mobileHome.diningRoom', value: 'Dining Room' },
  { label: 'selectOptions.mobileHome.livingRoom', value: 'Living Room' },
  { label: 'selectOptions.mobileHome.other', value: 'Other' },
];

export const capreitMobileHomeCommonAreaLocations = [
  { label: 'selectOptions.mobileHome.garbageCompound', value: 'Garbage Compound' },
  { label: 'selectOptions.mobileHome.clubhouse', value: 'Clubhouse' },
  { label: 'selectOptions.mobileHome.commercial', value: 'Commercial' },
  { label: 'selectOptions.mobileHome.generator', value: 'Generator' },
  { label: 'selectOptions.mobileHome.grounds', value: 'Grounds' },
  { label: 'selectOptions.mobileHome.laundryRoom', value: 'Laundry Room' },
  { label: 'selectOptions.mobileHome.liftStation', value: 'Lift Station' },
  { label: 'selectOptions.mobileHome.maintenanceBuilding', value: 'Maintenance Building' },
  { label: 'selectOptions.mobileHome.office', value: 'Office' },
  { label: 'selectOptions.mobileHome.parkingLotsCompound', value: 'Parking Lots/Compound' },
  { label: 'selectOptions.mobileHome.playgrounds', value: 'Playgrounds' },
  { label: 'selectOptions.mobileHome.poolAndChangeRooms', value: 'Pool And Change Rooms' },
  { label: 'selectOptions.mobileHome.pumpHouse', value: 'Pump House' },
  { label: 'selectOptions.mobileHome.recreationRooms', value: 'Recreation Rooms' },
  { label: 'selectOptions.mobileHome.storageLockers', value: 'Storage/Lockers' },
  { label: 'selectOptions.mobileHome.vacantLot', value: 'Vacant Lot' },
];

export const capreitTenantCategories = [
  { label: 'selectOptions.appliances', value: 'Appliances' },
  { label: 'selectOptions.doorsWindows', value: 'Doors/Windows' },
  { label: 'selectOptions.electrical', value: 'Electrical' },
  { label: 'selectOptions.flooring', value: 'Flooring' },
  { label: 'selectOptions.heatingCooling', value: 'Heating/Cooling' },
  { label: 'selectOptions.pestControl', value: 'Pest Control' },
  { label: 'selectOptions.plumbing', value: 'Plumbing' },
  { label: 'selectOptions.other', value: 'Other' },
  { label: 'selectOptions.wallsCeiling', value: 'Walls/Ceiling' },
];

export const capreitSuiteCategories = [
  { label: 'selectOptions.appliancesDishwasher', value: 'Appliances (Dishwasher)' },
  { label: 'selectOptions.appliancesDryer', value: 'Appliances (Dryer)' },
  { label: 'selectOptions.appliancesFridge', value: 'Appliances (Fridge)' },
  { label: 'selectOptions.appliancesHoodrange', value: 'Appliances (Hood Range)' },
  { label: 'selectOptions.appliancesOther', value: 'Appliances (Other)' },
  { label: 'selectOptions.appliancesStove', value: 'Appliances (Stove)' },
  { label: 'selectOptions.appliancesWasher', value: 'Appliances (Washer)' },
  { label: 'selectOptions.appliances', value: 'Appliances' },
  { label: 'selectOptions.bathtubReplace', value: 'Bathtub (Full Tub Surround Replacement)' },
  { label: 'selectOptions.bathtubReglaze', value: 'Bathtub - Re-glaze' },
  { label: 'selectOptions.cabinetsVanity', value: 'Cabinets (Bathroom Vanity)' },
  { label: 'selectOptions.cabinetsCountertop', value: 'Cabinets (Countertop)' },
  { label: 'selectOptions.cabinetsKitchen', value: 'Cabinets (Kitchen Cabinets)' },
  { label: 'selectOptions.doorsWindows', value: 'Doors and Windows' },
  { label: 'selectOptions.doorsWindowsCloset', value: 'Doors and Windows (Closet Doors)' },
  { label: 'selectOptions.doorsWindowsPatio', value: 'Doors and Windows (Patio Door/Screen)' },
  { label: 'selectOptions.doorsWindowsSuite', value: 'Doors and Windows (Suite Doors)' },
  { label: 'selectOptions.doorsWindowsScreen', value: 'Doors and Windows (Window/Screen)' },
  { label: 'selectOptions.electrical', value: 'Electrical' },
  { label: 'selectOptions.electricalFansVents', value: 'Electrical (Fans/Vents)' },
  { label: 'selectOptions.electricalLightBulbs', value: 'Electrical (Light Bulbs)' },
  { label: 'selectOptions.electricalLightFixtures', value: 'Electrical (Light Fixture)' },
  {
    label: 'selectOptions.electricalLightSwitchesPlugsCovers',
    value: 'Electrical (Light Switches/Plugs/Covers)',
  },
  { label: 'selectOptions.electricalNoPowerFuses', value: 'Electrical (No Power/Fuses)' },
  { label: 'selectOptions.flooring', value: 'Flooring' },

  { label: 'selectOptions.flooringLaminatePlank', value: 'Flooring (Laminate/Plank)' },
  { label: 'selectOptions.flooringCeramic', value: 'Flooring (Ceramic)' },
  { label: 'selectOptions.flooringParquet', value: 'Flooring (Parquet)' },
  {
    label: 'selectOptions.hardwareCabinetHingesHandles',
    value: 'Hardware (Cabinet Hinges/Handles)',
  },
  { label: 'selectOptions.hardwareCableBoxCovers', value: 'Hardware (Cable Box Covers)' },
  { label: 'selectOptions.hardwareDoorsHandlesLocks', value: 'Hardware (Doors/Handles/Locks)' },
  {
    label: 'selectOptions.hardwareMailboxFrontEntranceLock',
    value: 'Hardware (Mailbox/Front Entrance Lock Change)',
  },
  { label: 'selectOptions.hardwareShelving', value: 'Hardware (Shelving)' },
  {
    label: 'selectOptions.hardwareTowelShowerPaper',
    value: 'Hardware (Towel/Shower/Paper holders)',
  },
  { label: 'selectOptions.healthSafetyBrokenGlass', value: 'Health and Safety (Broken Glass)' },
  {
    label: 'selectOptions.healthSafetySmokeCODetector',
    value: 'Health and Safety (Smoke/CO Detectors)',
  },
  { label: 'selectOptions.healthSafetyWindowLocks', value: 'Health and Safety (Window Locks)' },
  { label: 'selectOptions.heatingACHeatPumpUnit', value: 'Heating (AC - Heat Pump Unit)' },
  { label: 'selectOptions.heatingFurnace', value: 'Heating (Furnace)' },
  { label: 'selectOptions.heatingLimted', value: 'Heating (Limited Heat)' },
  { label: 'selectOptions.heatingNone', value: 'Heating (No Heat)' },
  { label: 'selectOptions.heatingRadiatorCovers', value: 'Heating (Radiator Covers)' },
  { label: 'selectOptions.heatingThermostat', value: 'Heating (Thermostat)' },
  { label: 'selectOptions.heatingCooling', value: 'Heating/Cooling' },
  { label: 'selectOptions.leaksExterior', value: 'Leaks (Exterior)' },
  { label: 'selectOptions.leaksNeighbour', value: 'Leaks (Flooding from Neighbouring Unit)' },
  { label: 'selectOptions.other', value: 'Other' },
  { label: 'selectOptions.adminAddPhoneIntercom', value: 'Other (Admin Add Phone # to Intercom)' },
  { label: 'selectOptions.adminResidentFeedback', value: 'Other (Admin Resident Feedback)' },
  { label: 'selectOptions.otherCaulking', value: 'Other (Caulking)' },
  { label: 'selectOptions.otherMoldTreatment', value: 'Other (Mold Treatment)' },
  { label: 'selectOptions.otherSuiteTurnover', value: 'Other (Suite Turnover)' },
  {
    label: 'selectOptions.pestControlBedBugBlockTreatment',
    value: 'Pest (Bed Bug Block Treatment)',
  },
  {
    label: 'selectOptions.pestControlBedBugTreatment',
    value: 'Pest (Bed Bug Treatment)',
  },
  {
    label: 'selectOptions.pestInspection',
    value: 'Pest (Inspection)',
  },
  { label: 'selectOptions.pestControlOther', value: 'Pest (Other Pest Inspection)' },
  {
    label: 'selectOptions.pestControlRoachesBlockTreatment',
    value: 'Pest (Roaches Block Treatment)',
  },
  {
    label: 'selectOptions.pestControlRoachesTreatment',
    value: 'Pest (Roaches Treatment)',
  },
  {
    label: 'selectOptions.pestControlRodentsBlockTreatment',
    value: 'Pest (Rodent Block Treatment)',
  },
  {
    label: 'selectOptions.pestControlRodentTreatment',
    value: 'Pest (Rodent Treatment)',
  },
  { label: 'selectOptions.pestControl', value: 'Pest Control' },
  { label: 'selectOptions.plumbing', value: 'Plumbing' },
  { label: 'selectOptions.plumbingCartridges', value: 'Plumbing (Cartridges)' },
  { label: 'selectOptions.plumbingHotWater', value: 'Plumbing (Hot Water Tank)' },
  { label: 'selectOptions.plumbingNoWater', value: 'Plumbing (No Water/No Hot Water)' },
  { label: 'selectOptions.plumbingPipeLeak', value: 'Plumbing (Pipe Leak)' },
  { label: 'selectOptions.plumbingPtrapDrains', value: 'Plumbing (Ptrap/Drains)' },
  { label: 'selectOptions.plumbingReInstallToilet', value: 'Plumbing (Re-Install toilet)' },
  {
    label: 'selectOptions.plumbingShowerDivertorShowerHead',
    value: 'Plumbing (Shower Diverter - Shower Head)',
  },
  { label: 'selectOptions.plumbingSinkClogged', value: 'Plumbing (Sink Clogged)' },
  { label: 'selectOptions.plumbingSink', value: 'Plumbing (Sink)' },
  { label: 'selectOptions.plumbingTaps', value: 'Plumbing (Taps)' },
  { label: 'selectOptions.plumbingToiletBroken', value: 'Plumbing (Toilet Broken)' },
  { label: 'selectOptions.plumbingToiletClogged', value: 'Plumbing (Toilet Clogged)' },
  { label: 'selectOptions.plumbingToiletFillValve', value: 'Plumbing (Toilet Fill Valve)' },
  { label: 'selectOptions.plumbingToiletFlushHandles', value: 'Plumbing (Toilet Flush Handles)' },
  { label: 'selectOptions.plumbingToiletGasket', value: 'Plumbing (Toilet Gasket)' },
  {
    label: 'selectOptions.plumbingToiletLeakingRunning',
    value: 'Plumbing (Toilet Leaking/Running)',
  },
  { label: 'selectOptions.plumbingTubDrainOverflow', value: 'Plumbing (Tub Drain & Overflow)' },
  { label: 'selectOptions.plumbingZoneValves', value: 'Plumbing (Zone Valves)' },
  { label: 'selectOptions.wallsCeiling', value: 'Walls and Ceiling' },
  {
    label: 'selectOptions.wallsCeilingPaintPlaster',
    value: 'Walls and Ceiling (Paint/Plaster - Large)',
  },
  {
    label: 'selectOptions.wallsCeilingPaintPlasterTouchUps',
    value: 'Walls and Ceiling (Paint/Plaster - Touch-ups)',
  },
];

export const capreitCommonAreaCategories = [
  { label: 'selectOptions.abandonedItems', value: 'Abandoned Items' },
  { label: 'selectOptions.abandonedVehicles', value: 'Abandoned Vehicles' },
  { label: 'selectOptions.partyRoomAppliance', value: 'Party Room Appliance' },
  { label: 'selectOptions.laundryWasherDryer', value: 'Laundry Room (Washer/Dryer)' },
  { label: 'selectOptions.appliancesWasherDryer', value: 'Appliances (Washer/Dryer)' },
  { label: 'selectOptions.binsClearing', value: 'Bins (Clearing)' },
  { label: 'selectOptions.binsMoving', value: 'Bins (Moving)' },
  { label: 'selectOptions.binsRepairs', value: 'Bins (Repairs)' },
  { label: 'selectOptions.binsCleanliness', value: 'Bins (Cleanliness)' },
  { label: 'selectOptions.doorsRepairAdjusting', value: 'Doors (Repair/Adjusting)' },
  { label: 'selectOptions.doorsReplacement', value: 'Doors (Replacement)' },
  { label: 'selectOptions.electricalFansVents', value: 'Electrical (Fans/Vents)' },
  { label: 'selectOptions.electricalLightBulbs', value: 'Electrical (Light Bulbs)' },
  { label: 'selectOptions.electricalLightFixtures', value: 'Electrical (Light Fixture)' },
  {
    label: 'selectOptions.electricalLightSwitchesPlugsCovers',
    value: 'Electrical(Light Switches/Plugs/Covers)',
  },
  { label: 'selectOptions.electricalNoPowerFuses', value: 'Electrical (No Power/Fuses)' },
  {
    label: 'selectOptions.elevatorCleaningObstructions',
    value: 'Elevator - Cleaning/Obstructions',
  },
  { label: 'selectOptions.elevatorPutOnService', value: 'Elevator - Put on Service' },
  { label: 'selectOptions.equipmentOperationalCheck', value: 'Equipment Operational Check' },
  { label: 'selectOptions.fansCheckClean', value: 'Fans Check/Clean' },
  { label: 'selectOptions.filtersReplaceClean', value: 'Filters Replace/Clean' },
  { label: 'selectOptions.flooringRepairs', value: 'Flooring (Repairs)' },
  { label: 'selectOptions.flooringReplace', value: 'Flooring (Replace)' },
  { label: 'selectOptions.garbageCompactor', value: 'Garbage Compactor' },
  { label: 'selectOptions.grafitti', value: 'Graffiti' },
  { label: 'selectOptions.grassShrubbery', value: 'Grass/Shrubbery' },
  { label: 'selectOptions.hardware', value: 'Hardware' },
  {
    label: 'selectOptions.hardwareCabinetHingesHandles',
    value: 'Hardware (Cabinet Hinges/Handles)',
  },
  { label: 'selectOptions.hardwareCableBoxCovers', value: 'Hardware (Cable Box Covers)' },
  { label: 'selectOptions.hardwareHingesKnobs', value: 'Hardware (Hinges/Knobs)' },
  {
    label: 'selectOptions.hardwareMailboxFrontEntranceLock',
    value: 'Hardware (Mailbox/Front Entrance Lock Change)',
  },
  { label: 'selectOptions.hardwareShelving', value: 'Hardware (Shelving)' },
  { label: 'selectOptions.healthSafetyBrokenGlass', value: 'Health and Safety (Broken Glass)' },
  {
    label: 'selectOptions.healthSafetySmokeCODetector',
    value: 'Health and Safety (Smoke/CO Detectors)',
  },
  { label: 'selectOptions.heatingNoLimted', value: 'Heating (No/Limited Heat)' },
  { label: 'selectOptions.heatingThermostat', value: 'Heating (Thermostat)' },
  { label: 'selectOptions.heatingTracingCables', value: 'Heating/Tracing Cables' },
  { label: 'selectOptions.leaksCieling', value: 'Leaks (Ceiling)' },
  { label: 'selectOptions.leaksOutsideWall', value: 'Leaks (Outside Wall)' },
  { label: 'selectOptions.locksKeysCommonAreas', value: 'Locks/Keys - Common Areas' },
  { label: 'selectOptions.locksKeysMail', value: 'Locks/Keys - Mail' },
  { label: 'selectOptions.locksKeysUnits', value: 'Locks/Keys - Units' },
  { label: 'selectOptions.leaksPaintPlasterLarge', value: 'Paint/Plaster - Large' },
  { label: 'selectOptions.leaksPaintPlasterTouchups', value: 'Paint/Plaster - Touch-ups' },
  { label: 'selectOptions.pestControl', value: 'Pest Control' },
  { label: 'selectOptions.plumbingFixtures', value: 'Plumbing (Fixtures)' },
  { label: 'selectOptions.plumbingPipeLeak', value: 'Plumbing (Pipe Leak)' },
  { label: 'selectOptions.plumbingPtrapDrains', value: 'Plumbing (Ptrap/Drains)' },
  { label: 'selectOptions.plumbingSink', value: 'Plumbing (Sink)' },
  { label: 'selectOptions.plumbingToiletBroken', value: 'Plumbing (Toilet Broken)' },
  { label: 'selectOptions.plumbingToiletClogged', value: 'Plumbing (Toilet Clogged)' },
  { label: 'selectOptions.poolChemicalsTests', value: 'Pool Chemicals/Tests' },
  { label: 'selectOptions.rampHeating', value: 'Ramp Heating' },
  { label: 'selectOptions.removeLargeItems', value: 'Remove Large Items' },
  { label: 'selectOptions.safetyHazards', value: 'Safety Hazards' },
  { label: 'selectOptions.securitySystemsEquipment', value: 'Security Systems - Equipment' },
  { label: 'selectOptions.securitySystemsOperational', value: 'Security Systems - Operational' },
  { label: 'selectOptions.snowClearing', value: 'Snow Clearing' },
  { label: 'selectOptions.ventClearing', value: 'Vent Clearing' },
];

export const capreitMobileHomeTenantCategories = [
  {
    label: 'selectOptions.mobileHome.constructionAlterationRequest',
    value: 'Construction/Alteration Request',
  },
  { label: 'selectOptions.mobileHome.drainage', value: 'Drainage' },
  { label: 'selectOptions.mobileHome.electrical', value: 'Electrical' },
  { label: 'selectOptions.mobileHome.grass', value: 'Grass' },
  { label: 'selectOptions.mobileHome.tree', value: 'Tree' },
  { label: 'selectOptions.mobileHome.sewer', value: 'Sewer' },
  { label: 'selectOptions.mobileHome.plumbing', value: 'Plumbing' },
  { label: 'selectOptions.mobileHome.purchaseService', value: 'Purchase Service' },
  { label: 'selectOptions.mobileHome.water', value: 'Water' },
  { label: 'selectOptions.mobileHome.other', value: 'Other' },
  { label: 'selectOptions.mobileHome.rentalHomeAppliance', value: 'Rental Home - Appliance' },
  { label: 'selectOptions.mobileHome.rentalHomePlumbing', value: 'Rental Home - Plumbing' },
  { label: 'selectOptions.mobileHome.rentalHomeElectrical', value: 'Rental Home - Electrical' },
  { label: 'selectOptions.mobileHome.rentalHomeOther', value: 'Rental Home - Other' },
];

export const capreitMobileHomeSuiteCategories = [
  { label: 'selectOptions.appliances', value: 'Appliances' },
  {
    label: 'selectOptions.mobileHome.constructionAlterationRequest',
    value: 'Construction/Alteration Request',
  },
  {
    label: 'selectOptions.mobileHome.drainage',
    value: 'Drainage',
  },
  {
    label: 'selectOptions.mobileHome.drainageFlooding',
    value: 'Drainage (Flooding)',
  },
  {
    label: 'selectOptions.mobileHome.drainageCulvert',
    value: 'Drainage (Culvert)',
  },
  { label: 'selectOptions.doorsWindows', value: 'Doors/Windows' },
  { label: 'selectOptions.electrical', value: 'Electrical' },
  {
    label: 'selectOptions.mobileHome.ElectricalCoachlight',
    value: 'Electrical (Coachlight)',
  },
  {
    label: 'selectOptions.mobileHome.ElectricalStreetlight',
    value: 'Electrical (Streetlight)',
  },
  {
    label: 'selectOptions.mobileHome.ElectricalOther',
    value: 'Electrical (Other)',
  },
  {
    label: 'selectOptions.mobileHome.ElectricalHeatTape',
    value: 'Electrical (Heat Tape)',
  },
  { label: 'selectOptions.flooring', value: 'Flooring' },
  {
    label: 'selectOptions.mobileHome.grass',
    value: 'Grass',
  },
  {
    label: 'selectOptions.mobileHome.GrassCut',
    value: 'Grass (Cut)',
  },
  { label: 'selectOptions.heatingCooling', value: 'Heating/Cooling' },
  { label: 'selectOptions.pestControl', value: 'Pest Control' },
  { label: 'selectOptions.plumbing', value: 'Plumbing' },
  {
    label: 'selectOptions.mobileHome.PlumbingBathtub',
    value: 'Plumbing (Bathtub)',
  },
  {
    label: 'selectOptions.mobileHome.purchaseService',
    value: 'Purchase Service',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServiceCutGrass',
    value: 'Purchase Service (Cut Grass)',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServicePlowDriveway',
    value: 'Purchase Service (Plow Driveway)',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServiceSkirting',
    value: 'Purchase Service (Skirting)',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServicePlumbing',
    value: 'Purchase Service (Plumbing)',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServiceSupplyMaterial',
    value: 'Purchase Service (Supply Material)',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServiceOther',
    value: 'Purchase Service (Other)',
  },
  {
    label: 'selectOptions.mobileHome.PurchaseServiceRemoveGarbage',
    value: 'Purchase Service (Remove Garbage)',
  },
  {
    label: 'selectOptions.mobileHome.PlumbingPipeLeak',
    value: 'Plumbing (Pipe Leak)',
  },
  {
    label: 'selectOptions.mobileHome.PlumbingPtrapDrains',
    value: 'Plumbing (Ptrap/Drains)',
  },
  {
    label: 'selectOptions.mobileHome.PlumbingSink',
    value: 'Plumbing (Sink)',
  },
  {
    label: 'selectOptions.mobileHome.PlumbingTaps',
    value: 'Plumbing (Taps)',
  },
  {
    label: 'selectOptions.mobileHome.PlumbingTubDrain',
    value: 'Plumbing (Tub Drain)',
  },
  {
    label: 'selectOptions.mobileHome.RoadPothole',
    value: 'Road (Pothole)',
  },
  {
    label: 'selectOptions.mobileHome.RoadOther',
    value: 'Road (Other)',
  },
  {
    label: 'selectOptions.mobileHome.sewer',
    value: 'Sewer',
  },
  {
    label: 'selectOptions.mobileHome.SewerBackupInterior',
    value: 'Sewer (Backup Interior)',
  },
  {
    label: 'selectOptions.mobileHome.SewerFrozen',
    value: 'Sewer (Frozen)',
  },
  {
    label: 'selectOptions.mobileHome.SewerBackupExterior',
    value: 'Sewer (Backup Exterior)',
  },
  {
    label: 'selectOptions.mobileHome.tree',
    value: 'Tree',
  },
  {
    label: 'selectOptions.mobileHome.TreeTrim',
    value: 'Tree (Trim)',
  },
  {
    label: 'selectOptions.mobileHome.TreeCut',
    value: 'Tree (Cut)',
  },
  { label: 'selectOptions.wallsCeiling', value: 'Walls/Ceiling' },
  {
    label: 'selectOptions.mobileHome.water',
    value: 'Water',
  },
  {
    label: 'selectOptions.mobileHome.WaterNoWater',
    value: 'Water (No Water)',
  },
  {
    label: 'selectOptions.mobileHome.WaterLowPressure',
    value: 'Water (Low Pressure)',
  },
  {
    label: 'selectOptions.mobileHome.WaterDiscoloredWater',
    value: 'Water (Discolored Water)',
  },
  {
    label: 'selectOptions.mobileHome.WaterBrokenPipe',
    value: 'Water (Broken Pipe)',
  },
  {
    label: 'selectOptions.mobileHome.WaterFrozenLine',
    value: 'Water (Frozen Line)',
  },
  {
    label: 'selectOptions.mobileHome.Wildlife',
    value: 'Wildlife',
  },
  {
    label: 'selectOptions.mobileHome.Other',
    value: 'Other',
  },
  {
    label: 'selectOptions.mobileHome.OtherDriveway',
    value: 'Other (Driveway)',
  },
  {
    label: 'selectOptions.mobileHome.OtherLandscaping',
    value: 'Other (Landscaping)',
  },
  {
    label: 'selectOptions.mobileHome.OtherPest',
    value: 'Other (Pest)',
  },
  {
    label: 'selectOptions.mobileHome.rentalHomeAppliance',
    value: 'Rental Home - Appliance',
  },
  {
    label: 'selectOptions.mobileHome.rentalHomeElectrical',
    value: 'Rental Home - Electrical',
  },
  {
    label: 'selectOptions.mobileHome.rentalHomeOther',
    value: 'Rental Home - Other',
  },
  {
    label: 'selectOptions.mobileHome.rentalHomePlumbing',
    value: 'Rental Home - Plumbing',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePlumbingToiletBroken',
    value: 'Rental Home - Plumbing (Toilet Broken)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePlumbingToiletClogged',
    value: 'Rental Home - Plumbing (Toilet Clogged)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePlumbingToiletFlushHandles',
    value: 'Rental Home - Plumbing (Toilet Flush Handles)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePlumbingToiletLeakingRunning',
    value: 'Rental Home - Plumbing (Toilet Leaking/Running)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePlumbingShowerHeads',
    value: 'Rental Home - Plumbing (Shower Heads)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePlumbing-CaulkBathtub',
    value: 'Rental Home - Plumbing -Caulk (Bathtub)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeApplianceDishwasher',
    value: 'Rental Home - Appliance (Dishwasher)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeApplianceFridge',
    value: 'Rental Home - Appliance (Fridge)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeApplianceHoodRange',
    value: 'Rental Home - Appliance (Hood Range)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeApplianceStove',
    value: 'Rental Home - Appliance (Stove) ',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeApplianceWasherDryer',
    value: 'Rental Home - Appliance (Washer/Dryer)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeElectricalLightBulbs',
    value: 'Rental Home - Electrical (Light Bulbs)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeElectricalLightFixture',
    value: 'Rental Home - Electrical (Light Fixture)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeElectricalLightSwitchesPlugsCovers',
    value: 'Rental Home - Electrical (Light Switches/Plugs/Covers)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeElectricalNoPowerFuses',
    value: 'Rental Home - Electrical (No Power/Fuses)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeDoorsRepairAdjusting',
    value: 'Rental Home - Doors (Repair/Adjusting)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeDoorsReplacement',
    value: 'Rental Home - Doors (Replacement)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeFlooringRepairs',
    value: 'Rental Home - Flooring (Repairs)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeDeckSteps',
    value: 'Rental Home - Deck/Steps',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeDriveway',
    value: 'Rental Home - Driveway',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHardwareCabinetHingesHandles',
    value: 'Rental Home - Hardware (Cabinet Hinges/Handles)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHardwareDoorsHandlesLocks',
    value: 'Rental Home - Hardware (Doors/Handles/Locks)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHardwareLockChange',
    value: 'Rental Home - Hardware (Lock Change)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHardwareShelving',
    value: 'Rental Home - Hardware (Shelving)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHardwareTowelShowerPaperHolders',
    value: 'Rental Home - Hardware (Towel/Shower/Paper Holders)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHealth&SafetySmokeCoDetectors',
    value: 'Rental Home - Health & Safety (Smoke/Co Detectors)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHeatingFurnace',
    value: 'Rental Home - Heating (Furnace)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHeatingNoLimitedHeat',
    value: 'Rental Home - Heating (No/Limited Heat)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeHeatingThermostat',
    value: 'Rental Home - Heating (Thermostat)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeLeaksCeiling',
    value: 'Rental Home - Leaks (Ceiling)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeLeaksFloor',
    value: 'Rental Home - Leaks (Floor)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeLeaksInteriorWall',
    value: 'Rental Home - Leaks (Interior Wall)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeLeaksNextToPatioDoor',
    value: 'Rental Home - Leaks (Next To Patio Door)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeLeaksNextToWindow',
    value: 'Rental Home - Leaks (Next To Window)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeLeaksOutsideWall',
    value: 'Rental Home - Leaks (Outside Wall)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePaintPlasterLarge',
    value: 'Rental Home - Paint/Plaster (Large)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomePaintPlasterTouch',
    value: 'Rental Home - Paint/Plaster (Touch-Ups)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeWindowPatioDoorDrafty',
    value: 'Rental Home - Window/Patio Door (Drafty)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeWindowPatioDoorScreenLeaks',
    value: 'Rental Home - Window/Patio Door/Screen (Leaks)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeWindowPatioDoorScreenRepair',
    value: 'Rental Home - Window/Patio Door/Screen (Repair)',
  },
  {
    label: 'selectOptions.mobileHome.RentalHomeWindowPatioDoorScreenReplace',
    value: 'Rental Home - Window/Patio Door/Screen (Replace)',
  },
];

export const capreitMobileHomeCommonAreaCategories = [
  {
    label: 'selectOptions.mobileHome.abandonedItems',
    value: 'Abandoned Items',
  },
  {
    label: 'selectOptions.mobileHome.abandonedVehicles',
    value: 'Abandoned Vehicles',
  },
  {
    label: 'selectOptions.mobileHome.alarmAlarme',
    value: 'Alarm',
  },
  {
    label: 'selectOptions.mobileHome.clubhouseAppliance',
    value: 'Clubhouse Appliance',
  },
  {
    label: 'selectOptions.mobileHome.culvert',
    value: 'Culvert',
  },
  {
    label: 'selectOptions.mobileHome.laundryRoomWasherDryer',
    value: 'Laundry Room (Washer/Dryer)',
  },
  {
    label: 'selectOptions.mobileHome.applianceWasherDryer',
    value: 'Appliance (Washer/Dryer)',
  },
  {
    label: 'selectOptions.mobileHome.binsClearing',
    value: 'Bins (Clearing)',
  },
  {
    label: 'selectOptions.mobileHome.cleanliness',
    value: 'Cleanliness',
  },
  {
    label: 'selectOptions.mobileHome.doorsRepairAdjusting',
    value: 'Doors (Repair/Adjusting)',
  },
  {
    label: 'selectOptions.mobileHome.doorsReplacement',
    value: 'Doors (Replacement)',
  },
  {
    label: 'selectOptions.mobileHome.drainage',
    value: 'Drainage',
  },
  {
    label: 'selectOptions.mobileHome.deckSteps',
    value: 'Deck/Steps',
  },
  {
    label: 'selectOptions.mobileHome.electrical',
    value: 'Electrical',
  },
  {
    label: 'selectOptions.mobileHome.electricalOther',
    value: 'Electrical (Other)',
  },
  {
    label: 'selectOptions.mobileHome.electricalLightBulbs',
    value: 'Electrical (Light Bulbs)',
  },
  {
    label: 'selectOptions.mobileHome.electricalLightFixture',
    value: 'Electrical (Light Fixture)',
  },
  {
    label: 'selectOptions.mobileHome.electricalLightSwitchesPlugsCovers',
    value: 'Electrical (Light Switches/Plugs/Covers)',
  },
  {
    label: 'selectOptions.mobileHome.electricalNoPowerBreakersFuses',
    value: 'Electrical (No Power/Breakers/Fuses)',
  },
  {
    label: 'selectOptions.mobileHome.equipmentOperationalCheck',
    value: 'Equipment (Operational Check)',
  },
  {
    label: 'selectOptions.mobileHome.electricalStreetLights',
    value: 'Electrical (Street Lights)',
  },
  {
    label: 'selectOptions.mobileHome.flooring',
    value: 'Flooring',
  },
  {
    label: 'selectOptions.mobileHome.garbage',
    value: 'Garbage',
  },
  {
    label: 'selectOptions.mobileHome.graffiti',
    value: 'Graffiti',
  },
  {
    label: 'selectOptions.mobileHome.grass',
    value: 'Grass',
  },
  {
    label: 'selectOptions.mobileHome.grassShrubbery',
    value: 'Grass/Shrubbery',
  },
  {
    label: 'selectOptions.mobileHome.garden',
    value: 'Garden',
  },
  {
    label: 'selectOptions.mobileHome.hardware',
    value: 'Hardware',
  },
  {
    label: 'selectOptions.mobileHome.hardwareCabinet,HingesHandlesKnobs',
    value: 'Hardware (Cabinet, Hinges/Handles/Knobs)',
  },
  {
    label: 'selectOptions.mobileHome.healthSafety',
    value: 'Health & Safety',
  },
  {
    label: 'selectOptions.mobileHome.health&SafetySmokeCoDetectors',
    value: 'Health & Safety (Smoke/Co Detectors)',
  },
  {
    label: 'selectOptions.mobileHome.healthAndSafetyHydrants',
    value: 'Health And Safety-Hydrants',
  },
  {
    label: 'selectOptions.mobileHome.heatingNoLimitedHeat',
    value: 'Heating (No/Limited Heat)',
  },
  {
    label: 'selectOptions.mobileHome.leaksCeiling',
    value: 'Leaks (Ceiling)',
  },
  {
    label: 'selectOptions.mobileHome.leaksOutsideWall',
    value: 'Leaks (Outside Wall)',
  },
  {
    label: 'selectOptions.mobileHome.locksKeysCommonAreas',
    value: 'Locks/Keys (Common Areas)',
  },
  {
    label: 'selectOptions.mobileHome.locksKeysUnits',
    value: 'Locks/Keys (Units)',
  },
  {
    label: 'selectOptions.mobileHome.landscapin',
    value: 'Landscaping',
  },
  {
    label: 'selectOptions.mobileHome.padPreparation',
    value: 'Pad Preparation',
  },
  {
    label: 'selectOptions.mobileHome.paintPlasterLarge',
    value: 'Paint/Plaster (Large)',
  },
  {
    label: 'selectOptions.mobileHome.paintPlasterTouchUps',
    value: 'Paint/Plaster (Touch-Ups)',
  },
  {
    label: 'selectOptions.mobileHome.pestControl',
    value: 'Pest Control',
  },
  {
    label: 'selectOptions.mobileHome.plumbing',
    value: 'Plumbing',
  },
  {
    label: 'selectOptions.mobileHome.plumbingFixtures',
    value: 'Plumbing (Fixtures)',
  },
  {
    label: 'selectOptions.mobileHome.plumbingPipeLeak',
    value: 'Plumbing (Pipe Leak)',
  },
  {
    label: 'selectOptions.mobileHome.plumbingPtrapDrains',
    value: 'Plumbing (Ptrap/Drains)',
  },
  {
    label: 'selectOptions.mobileHome.plumbingSink',
    value: 'Plumbing (Sink)',
  },
  {
    label: 'selectOptions.mobileHome.plumbingToiletBroken',
    value: 'Plumbing (Toilet Broken)',
  },
  {
    label: 'selectOptions.mobileHome.plumbingToiletClogged',
    value: 'Plumbing (Toilet Clogged)',
  },
  {
    label: 'selectOptions.mobileHome.poolChemicalsTests',
    value: 'Pool Chemicals/Tests',
  },
  {
    label: 'selectOptions.mobileHome.purchaseService',
    value: 'Purchase Service',
  },
  {
    label: 'selectOptions.mobileHome.removeLargeItems',
    value: 'Remove Large Items',
  },
  {
    label: 'selectOptions.mobileHome.roadsPothole',
    value: 'Roads (Pothole)',
  },
  {
    label: 'selectOptions.mobileHome.roadsOther',
    value: 'Roads (Other)',
  },
  {
    label: 'selectOptions.mobileHome.skirting',
    value: 'Skirting',
  },
  {
    label: 'selectOptions.mobileHome.safetyHazards',
    value: 'Safety Hazards',
  },
  {
    label: 'selectOptions.mobileHome.securitySystemsEquipment',
    value: 'Security Systems (Equipment)',
  },
  {
    label: 'selectOptions.mobileHome.securitySystemsOperational',
    value: 'Security Systems (Operational)',
  },
  {
    label: 'selectOptions.mobileHome.snowClearing',
    value: 'Snow Clearing',
  },
  {
    label: 'selectOptions.mobileHome.signage',
    value: 'Signage',
  },
  {
    label: 'selectOptions.mobileHome.sewer',
    value: 'Sewer',
  },
  {
    label: 'selectOptions.mobileHome.sewerBackupInterior',
    value: 'Sewer Backup Interior',
  },
  {
    label: 'selectOptions.mobileHome.sewerBackupExterior',
    value: 'Sewer Backup Exterior',
  },
  {
    label: 'selectOptions.mobileHome.tree',
    value: 'Tree',
  },
  {
    label: 'selectOptions.mobileHome.other',
    value: 'Other',
  },
  {
    label: 'selectOptions.mobileHome.water',
    value: 'Water',
  },
  {
    label: 'selectOptions.mobileHome.waterNoWater',
    value: 'Water (No Water)',
  },
  {
    label: 'selectOptions.mobileHome.waterLowPressure',
    value: 'Water (Low Pressure)',
  },
];

export const tenantPortalMaintenanceRequestType = [
  { label: 'selectOptions.isMaintenance', value: 'Portal Request - Maintenance' },
  { label: 'selectOptions.isOther', value: 'Portal Request - Other' },
];

export const vendorCategory = [
  'Appliance',
  'Cable',
  'Cleaning',
  'Electrical',
  'Fixtures',
  'Flooring',
  'Garbage',
  'General Contracting',
  'Heating/Cooling',
  'Internet',
  'Other',
  'Painting',
  'Plumbing',
  'Utilities',
];

function compare(a, b) {
  if (a.value < b.value) return -1;
  if (a.value > b.value) return 1;
  return 0;
}
